import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAppIcBrowserNotifications32 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	style: { fill: "currentColor" },
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M26.21 26H5.79C3.7 26 2 24.34 2 22.3V16C2 15.45 2.45 15 3 15C3.55 15 4 15.45 4 16V22.3C4 23.24 4.8 24 5.79 24H26.21C27.2 24 28 23.24 28 22.3V9.7C28 8.76 27.2 8 26.21 8H12C11.45 8 11 7.55 11 7C11 6.45 11.45 6 12 6H26.21C28.3 6 30 7.66 30 9.7V22.3C30 24.34 28.3 26 26.21 26ZM4 9H3C2.45 9 2 9.45 2 10C2 10.55 2.45 11 3 11H4C4.55 11 5 10.55 5 10C5 9.45 4.55 9 4 9ZM7 8V7C7 6.45 6.55 6 6 6C5.45 6 5 6.45 5 7V8C5 8.55 5.45 9 6 9C6.55 9 7 8.55 7 8ZM7 13V12C7 11.45 6.55 11 6 11C5.45 11 5 11.45 5 12V13C5 13.55 5.45 14 6 14C6.55 14 7 13.55 7 13ZM9 9H8C7.45 9 7 9.45 7 10C7 10.55 7.45 11 8 11H9C9.55 11 10 10.55 10 10C10 9.45 9.55 9 9 9Z" })
});
export default SvgAppIcBrowserNotifications32;
